import { PROFILE_TYPES } from '@/utils/enums';

export default [
    {
        path: '/specialist',
        component: () => import('@/views/specialist'),
        name: 'specialist.home',
        meta: { auth: true },
    },
    {
        path: '/specialist/dash',
        component: () => import('@/views/dash'),
        name: 'specialist.dash',
        meta: { auth: true, allowRoles: [PROFILE_TYPES.SPECIALIST] },
        beforeEnter: (to, from, next) => {
            to.query = { ...to.query, partner_type: PROFILE_TYPES.SPECIALIST };
            next();
        },
    },
];
